import React from "react";
import Title from "../../../components/Title/Title";

const FullAgenda2026page = () => {
    return (
        <div>
            <Title>Full Agenda</Title>
            <p>
                TBD
            </p>
        </div>
    )
}

export default FullAgenda2026page;